<!-- 录入/修改菜肴弹窗 -->
<template>
  <el-dialog :title="titlePro || title" :visible.sync="isShow" :modal-append-to-body="true" top="100px" width="30%"
    custom-class="custom-dialog-class" @close="innerCloseCallBack">
    <template #default>
      <div class="dialog-container" v-loading="isLoading">
        <el-form :model="form" ref="formRef" label-width="130px" :rules="rules">
          <el-form-item label="菜肴名称：" prop="menuName">
            <el-input v-model="form.menuName" clearable placeholder="请输入" maxlength="10" show-word-limit />
          </el-form-item>
          <el-form-item label="饮食类型：" prop="dietType">
            <el-select v-model="form.dietType" multiple clearable placeholder="请选择">
              <el-option v-for="item in dietTypeList" :key="item.dictKey" :label="item.dictValue"
                :value="item.dictKey" />
            </el-select>
          </el-form-item>
          <el-form-item label="菜肴分类：" prop="foodType">
            <el-select v-model="form.foodType" clearable placeholder="请选择">
              <el-option v-for="item in foodTypeList" :key="item.dictKey" :label="item.dictValue"
                :value="item.dictKey" />
            </el-select>
          </el-form-item>
          <CustomSerchInputItem ref="materialTable" :isCheck="isMaterialCheck"
            :changeMaterialCheck="changeMaterialCheck" :tableProps="tableProps" @updataFn="updataFn" />
          <el-form-item label="用餐时段：" prop="mealTime">
            <el-select v-model="form.mealTime" multiple clearable placeholder="请选择">
              <el-option v-for="item in mealTimeList" :key="item.dictKey" :label="item.dictValue"
                :value="item.dictKey" />
            </el-select>
          </el-form-item>
          <el-form-item label="中医证型：" prop="syndromeType">
            <el-select v-model="form.syndromeType" clearable placeholder="请选择">
              <el-option v-for="item in syndromeTypeList" :key="item.dictKey" :label="item.dictValue"
                :value="item.dictKey" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="isShowDec" label="中医食补文案补充:" prop="tcmText">
            <el-input v-model="form.tcmText" type="textarea" :autosize="{ minRows: 4 }" maxlength="300"
              show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="单位转换：" prop="joinKcal">
            <div class="unitInput">
              <span>1g 等于</span><el-input-number :min="0" :controls="false" v-model="form.unitConversion" clearable
                placeholder="请输入" style="width: 30%;" /><span>ml</span>
            </div>
          </el-form-item>
          <el-form-item label="是否计入能量：" prop="joinKcal">
            <el-radio v-model="form.joinKcal" label="1">是</el-radio>
            <el-radio v-model="form.joinKcal" label="0">否</el-radio>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template #footer>
      <div class="dialog-footer">
        <slot :submitForm="submitForm" :toggleOpen="toggleOpen" :isUpdate="isUpdate"></slot>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import CustomSerchInputItem from "./customSerchInputItem.vue";
import { submitHint } from '../common'
import { post } from "@/api/http";
export default {
  name: "AddDialog",
  components: { CustomSerchInputItem },
  props: {
    syndromeTypeList: {
      type: Array,
      default: () => [],
    },
    mealTimeList: {
      type: Array,
      default: () => [],
    },
    dietTypeList: {
      type: Array,
      default: () => [],
    },
    foodTypeList: {
      type: Array,
      default: () => [],
    },
    isOpen: {
      type: Boolean,
      default: () => false,
    },
    toggleOpen: {
      type: Function,
      default: () => { },
    },
    submitCallBack: {
      type: Function,
      default: () => { },
    },
    closeCallBack: {
      typeof: Function,
      default: () => { },
    },
    // 每行数据
    row: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 区分是否是重新提交
    // reEdit - 重新提交
    operType: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    titlePro: {
      type: String,
      default: ''
    }
  },
  mounted() {
    if(this.row.id) {
      this.title = '编辑菜肴';
    }
    this.form.id = this.row.id || ""; // 菜肴id
    this.form.menuName = this.row.dishName || ""; // 菜肴名称
    this.form.dietType = this.row.dietType?.split(",") || []; // 饮食类型
    this.form.foodType = this.row.dishCategory || ""; // 菜肴分类
    this.form.syndromeType = this.row.tcmSyndromeType || ""; // 中医证型
    this.form.mealTime = this.row.mealPeriod?.split(",") || []; // 用餐时段
    // 因为接口返回的是 true/false
    this.form.joinKcal = this.row.isCountEnergy || '1'; // 是否计入能量
    this.tableProps = this.row.ingredientDTOS || []; // 食材占比参数
    this.form.unitConversion = this.row.unitConversion || '' // 单位转换
    this.form.tcmText = this.row.tcmText || '' // 中医文案补充
    this.isMounted = true;
  },

  data() {
    return {
      form: {
        id: "",
        menuName: "", // 菜肴名称
        dietType: "", // 饮食类型
        foodType: "", // 菜肴分类
        mealTime: [], // 用餐时段
        syndromeType: "", // 中医证型
        joinKcal: "1", // 是否计入能量
        unitConversion: '',
        tcmText: '' // 中医文案补充
      },
      tableProps: [], // 食材占比参数
      materialList: [], // 食材占比列表
      isMaterialCheck: false, // 食材必填校验
      rules: {
        menuName: [
          { required: true, message: "请输入菜肴名称", trigger: "blur" },
        ],
        dietType: [
          { required: true, message: "请输入饮食类型", trigger: "blur" },
        ],
        foodType: [
          { required: true, message: "请输菜肴分类", trigger: "blur" },
        ],
        mealTime: [
          { required: true, message: "请选择饮食类型", trigger: "change" },
        ],
        syndromeType: [
          { required: true, message: "请选择中医证型", trigger: "change" },
        ],
      },
      isMounted: false, // 是否已经更新
      title: '录入菜肴'
    };
  },
  computed: {
    isShow: {
      get() {
        return this.isOpen;
      },
      set(val) {
        this.toggleOpen(val);
      },
    },
    // 包含中医证型才会展示
    isShowDec() {
      const syndromeKeyList = ['0', '1', '2'];
      return syndromeKeyList.includes(this.form.syndromeType);
    },
    // 是否修改过标识
    isUpdate() {
      if (!this.isMounted) {
        return true;
      }
      const rule1 = (this.form.menuName === (this.row.dishName || ''));
      const rule2 = (this.form.dietType?.join(',') === this.row.dietType);
      const rule3 = (this.form.foodType === (this.row.dishCategory || ''));
      const rule4 = (this.form.mealTime?.join(',') === this.row.mealPeriod);
      const rule5 = (this.form.joinKcal === (this.row.isCountEnergy || '1'));
      const rule6 = (JSON.stringify(this.tableProps?.map(item => ({
        ingredientName: item.ingredientName,
        proportion: item.ratio
      }))) === JSON.stringify(this.row.ingredientDTOS?.map(item => ({
        ingredientName: item.ingredientName,
        proportion: item.proportion
      }))));
      const rule7 = (Number(this.form.unitConversion) === Number((this.row.unitConversion || '')));
      const rule8 = (this.form.tcmText === (this.row.tcmText || ''));
      const rule9 = (this.form.syndromeType === (this.row.tcmSyndromeType || ''))
      return rule1 && rule2 && rule3 && rule4 && rule5 && rule6 && rule7 && rule8 && rule9;
    }
  },
  methods: {
    // 监听修改
    updataFn(e) {
      this.tableProps = e;
    },
    submitForm(formName) {
      // 食材列表校验
      const materialList = this.$refs.materialTable.table;
      this.$refs[formName].validate((valid) => {
        /* 代码冗余是因为两个分支语句都需要校验食材组件 */
        if (valid) {
          if (!materialList.length) {
            this.changeMaterialCheck(true);
            return false;
          } else {
            this.materialList = materialList;
          }
          this.submitFood();
        } else {
          if (!materialList.length) {
            this.changeMaterialCheck(true);
          } else {
            this.materialList = materialList;
          }
          return false;
        }
      });
    },
    // 提交菜肴
    async submitFood() {
      try {
        const param = {
          userId: this.$store.state.user_info.userId,
          id: this.form.id,
          dishName: this.form.menuName, // 菜肴名称
          dietType: this.form.dietType.join(","), // 饮食类型
          dishCategory: this.form.foodType, // 菜肴分类
          mealPeriod: this.form.mealTime.join(","), // 用餐时段
          tcmSyndromeType: this.form.syndromeType, // 中医证型
          isCountEnergy: this.form.joinKcal, // 是否计入能量
          unitConversion: this.form.unitConversion, // 单位换算比例
          tcmText: this.form.tcmText, // 中医文案补充
          ingredientDTOS: this.materialList.map((item) => ({
            id: item.id,
            ingredientName: item.ingredientName,
            proportion: item.ratio,
            energy: item.energy
          })),
        };
        // 审核中心重新提交复用
        if (this.operType === 'reEdit') {
          this.$emit("reEditCommit", param);
          return;
        }
        const result = await post("/dish/enter", param);
        const { code } = result;
        if (code === "SUCCESS") {
          this.toggleOpen(false); // 关闭弹窗
          this.submitCallBack();
          submitHint.call(this);
        } else {
          if (param.id === "") {
            this.$message.error("添加失败，请重试！");
          } else {
            this.$message.error("修改失败，请重试！");
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 切换食材校验状态
    changeMaterialCheck(isflag) {
      this.isMaterialCheck = isflag;
    },
    // 清空数据
    clearForm() {
      this.form = {
        menuName: "",
        dietType: [],
        foodType: "",
        mealTime: [],
        syndromeType: "",
        joinKcal: "1",
        unitConversion: "",
      };
      this.materialList = [];
    },
    // 关闭弹窗回调
    innerCloseCallBack() {
      this.clearForm(); // 清空表单数据
      this.closeCallBack(); // 关闭弹窗回调
      this.changeMaterialCheck(false); // 食材校置回状态
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-container {
  width: 400px;
  margin: 0 auto;
}

.unitInput {
  display: flex;
  gap: 10px;
}
</style>
